import React, { useEffect, useState } from "react";
import "./styles/index.scss";
import { connect } from "react-redux";
import Actions from "../../../actions";
import AddMember from "../inviteMember/AddPersonToDealForm";
import C from "../../../constants";
import Button from "../../common/forms/button";
import InvestorCreateBaseForm from "../createInvestors/investorCreateBaseForm";
import InvestorViewBaseForm from "../createInvestors/investorViewBaseForm";
import Delimiter from "../../common/forms/delimiter/Delimiter";
import { getUserName, simpleSort } from "../../../helpers/utils";
import * as api from "../../../api/generated-api";
import {
  configureAuthHeader,
  configureBaseUrl,
} from "../../../api/axiosConfig";
import {
  addExistingPersonAsDealInvestorMember,
  addNewPersonAsDealInvestorMember,
  getDealInvestor,
  getDealInvestorMembers,
  getInvestmentDealLegalEntitiesForDealAndDealInvestor,
  removeDealInvestorMember,
  updateDealInvestor,
} from "../../../api/deals/investors";
import {
  isCompanyMemberOrCounselForDeal,
  isEmpty,
  isInvestorMemberInInvestorOrg,
} from "../../../helpers/utilsTS";
import CustomErrorMessage from "../../common/errors/customErrorMessage";
import DealMemberRow from "../common/DealMemberRow";
import { getDealLegalEntitiesForUser } from "../../../api/deals/deallegalentities";
import { getPersonsByOrganizationSearch } from "../../../api/persons/persons";
import { DealsPageLayout } from "../dealsPageLayout/DealsPageLayout";
import { Box } from "@mui/material";
import { getDealInvestorDealLegalEntityInvestments } from "../../../api/deallegalentityinvestment/dealLegalEntityInvestments";
import { getDealById } from "../../../api/deals/deals";
import DKFormContainer from "../../common/forms/formContainer/DKFormContainer";
import DealPageTitleAndAction from "../common/DealPageTitleAndAction";
import { LegalEntitiesGridWrapper } from "./legalEntities/LegalEntitiesGridWrapper";
import { NewCashInvestmentGridWrapper } from "./cashInvestments/NewCashInvestmentGridWrapper";
import { SAFEConversionsGridWrapper } from "./safeConversions/SAFEConversionsGridWrapper";

//TODO: sometimes this is a DealLegalEntityInvestmentCreate, sometimes it is a DealLegalEntityInvestment; it is incorrectly typed
export type DealLegalEntityInvestmentFormEntry =
  api.DealLegalEntityInvestmentCreate & {
    id: number;
    signer: api.DealLegalEntity;
    wireDateReceived?: string;
  };

type DealInvestorsListPageProps = {
  token: string;
  orgId: number;
  user: api.User & {
    person: api.Person & {
      organizations_persons: {
        organization_id?: number;
        person_id: number;
        role_id: number;
        organization?: api.Organization;
      }[];
    };
  };
  dealInvestorId: number;
  dealId: number;
  updated: boolean;
  sendPersonInvitation: (
    dealId: number,
    personId: number,
    personRole: number,
    investorId: number
  ) => void;
  legalEntitiesFormFocus: boolean;
};

export type DealInvestorsFormError = {
  targetInvestment?: string;
  internalSplit?: string;
};

export const getTotalInvestmentAndPercentage = (
  updatedInvestmentFormEntries: DealLegalEntityInvestmentFormEntry[],
  investorTotalTargetInvestment: number
): { percentage: number; total: number } => {
  let total = 0;
  for (const updatedInvestment of updatedInvestmentFormEntries) {
    total += updatedInvestment.targetCashInvestment
      ? updatedInvestment.targetCashInvestment
      : 0;
  }
  const percentage = Math.round((total / +investorTotalTargetInvestment) * 100);
  return { total, percentage };
};

const DealInvestorDetailPage = (props: DealInvestorsListPageProps) => {
  const {
    token,
    orgId,
    user,
    dealInvestorId,
    dealId,
    updated,
    sendPersonInvitation,
  } = props;

  configureBaseUrl();
  configureAuthHeader(token);

  const [deal, setDeal] = useState<api.Deal>(null);
  const [investor, setInvestor] = useState<api.DealInvestor>(null);
  const [investorDealLegalEntities, setInvestorDealLegalEntities] = useState<
    api.DealLegalEntity[]
  >([]);
  const [isInvestorEdit, setIsInvestorEdit] = useState(false);
  useState(false);
  const [isOpenAddMemberPopup, setIsOpenAddMemberPopup] = useState(false);
  const [updatedInvestor, setUpdatedInvestor] =
    useState<api.DealInvestorCreate>(null);
  const [investmentDealLegalEntities, setInvestmentDealLegalEntities] =
    useState<api.DealLegalEntity[]>([]);
  const [newCashInvestments, setNewCashInvestments] = useState<
    api.DealLegalEntityInvestment[]
  >([]);
  const [safeInvestments, setSafeInvestments] = useState<
    api.DealLegalEntityInvestment[]
  >([]);
  const [isError, setIsError] = useState(false);
  const [dealLegalEntitiesForUser, setDealLegalEntitiesForUser] = useState<
    api.DealLegalEntity[]
  >([]);
  const [persons, setPersons] = useState<api.Person[]>([]);

  useEffect(() => {
    getDealLegalEntitiesForUser(orgId, dealId, (fetchedDealLegalEntities) => {
      setDealLegalEntitiesForUser(fetchedDealLegalEntities);
    });
  }, [orgId, dealId]);

  const fetchDealInvestorMembers = (investorId: number) => {
    getDealInvestorMembers(orgId, dealId, investorId, (fetchedInvestors) => {
      setInvestorDealLegalEntities(fetchedInvestors);
    });
  };

  const [formDataNewCashInvestments, setFormDataNewCashInvestments] =
    useState<Map<number, DealLegalEntityInvestmentFormEntry>>();

  const setAndSortFormDataNewCashInvestments = (
    newCashInvestments: Map<number, DealLegalEntityInvestmentFormEntry>
  ) => {
    setFormDataNewCashInvestments(
      new Map(
        [...newCashInvestments].sort((a, b) => {
          const investmentA = newCashInvestments.get(a[0]);
          const investmentB = newCashInvestments.get(b[0]);
          if (isEmpty(investmentA.name)) {
            return 1;
          } else {
            return simpleSort(investmentA.name, investmentB.name);
          }
        })
      )
    );
  };

  const copyNewCashInvestmentsToFormData = (
    dealLegalEntityInvestments: api.DealLegalEntityInvestment[]
  ) => {
    const formData = new Map<number, DealLegalEntityInvestmentFormEntry>();

    dealLegalEntityInvestments.forEach((dealLegalEntityInvestment) => {
      if (dealLegalEntityInvestment) {
        formData.set(dealLegalEntityInvestment.id, {
          ...dealLegalEntityInvestment,
        });
      }
    });
    setAndSortFormDataNewCashInvestments(formData);
  };

  const fetchDealLegalEntityInvestments = (investorId: number) => {
    getInvestmentDealLegalEntitiesForDealAndDealInvestor(
      orgId,
      dealId,
      investorId,
      (fetchedInvestmentDealLegalEntities) => {
        setInvestmentDealLegalEntities(fetchedInvestmentDealLegalEntities);
      }
    );

    getDealInvestorDealLegalEntityInvestments(
      orgId,
      dealId,
      investorId,
      (fetchedDealLegalEntityInvestments) => {
        const newCashInvestments = fetchedDealLegalEntityInvestments.filter(
          (investment) => {
            if (investment.type == api.DealLegalEntityInvestmentType.New_Cash) {
              return investment;
            }
          }
        );
        setNewCashInvestments(newCashInvestments);

        const safeInvestments = fetchedDealLegalEntityInvestments.filter(
          (investment) => {
            if (
              investment.type ==
              api.DealLegalEntityInvestmentType.SAFE_Conversion
            ) {
              return investment;
            }
          }
        );
        setSafeInvestments(safeInvestments);

        copyNewCashInvestmentsToFormData(newCashInvestments);
      }
    );
  };

  const isUserCompanyMember = isCompanyMemberOrCounselForDeal(
    user.person.organizations_persons,
    orgId,
    dealId,
    dealLegalEntitiesForUser
  );

  const canEditInvestorInfo = (investor: api.DealInvestor) => {
    return (
      isUserCompanyMember ||
      isInvestorMemberInInvestorOrg(user.person.organizations_persons, investor)
    );
  };

  useEffect(() => {
    const fetchDeal = () => {
      getDealById(orgId, dealId, (fetchedDeal) => {
        setDeal(fetchedDeal);
      });
    };
    const fetchInvestor = (investorId: number) => {
      getDealInvestor(orgId, dealId, investorId, (fetchedDealInvestor) => {
        setInvestor(fetchedDealInvestor);
      });
    };

    fetchDeal();
    fetchInvestor(dealInvestorId);
    fetchDealLegalEntityInvestments(dealInvestorId);
    fetchDealInvestorMembers(dealInvestorId);
  }, []);

  useEffect(() => {
    if (!isOpenAddMemberPopup) {
      fetchDealInvestorMembers(dealInvestorId);
    }
  }, [isOpenAddMemberPopup]);

  useEffect(() => {
    if (isInvestorEdit) {
      setUpdatedInvestor(investor);
    }
  }, [isInvestorEdit]);

  useEffect(() => {
    if (updated) {
      setIsInvestorEdit(false);
      setIsOpenAddMemberPopup(false);
      fetchDealInvestorMembers(dealInvestorId);
    }
  }, [updated]);

  if (!investor) {
    return null;
  }
  if (!deal || !formDataNewCashInvestments || !dealLegalEntitiesForUser) {
    return null;
  }

  const searchPersons = (searchString: string) => {
    getPersonsByOrganizationSearch(orgId, searchString, (fetchedPersons) => {
      setPersons(fetchedPersons);
    });
  };

  return (
    <DealsPageLayout
      showDealNav={false}
      leftHeaderAction={
        <DealPageTitleAndAction
          title={investor.name}
          breadcrumbs={[
            {
              dataTestId: "return-to-investors-link",
              title: "Investors",
              path: `/${orgId}/deals/${dealId}/edit/investors`,
            },
          ]}
        />
      }
    >
      {isError && <CustomErrorMessage />}
      <DKFormContainer>
        <Box>
          {!isInvestorEdit && (
            <InvestorViewBaseForm
              investor={investor}
              dealLegalEntityInvestments={newCashInvestments}
              clickToAvatar={undefined}
              onAddAddress={() => setIsInvestorEdit(!isInvestorEdit)}
            />
          )}
          {isInvestorEdit && (
            <InvestorCreateBaseForm
              investor={investor}
              onChange={(updatedInvestor) => {
                setUpdatedInvestor(updatedInvestor);
              }}
            />
          )}

          <Box
            display={"flex"}
            flexDirection={"row"}
            justifyContent={"flex-end"}
            alignItems={"top"}
          >
            {!isInvestorEdit && canEditInvestorInfo(investor) && (
              <Button
                data-testid="edit-investor-button"
                type="ghost"
                size="medium"
                onClick={() => {
                  setIsInvestorEdit(!isInvestorEdit);
                }}
              >
                edit
              </Button>
            )}
            {isInvestorEdit && (
              <Button
                data-testid="save-investor-update-button"
                type="primary"
                size="medium"
                onClick={() => {
                  const rollbackInvestor = { ...investor };

                  setInvestor({ ...investor, ...updatedInvestor });

                  const updatedDealInvestor: api.DealInvestorUpdate = {
                    name: updatedInvestor?.name,
                    isLead: updatedInvestor?.isLead,
                    targetInvestment: updatedInvestor?.targetInvestment,
                    line: updatedInvestor?.line,
                    city: updatedInvestor?.city,
                    state: updatedInvestor?.state,
                    zip: updatedInvestor?.zip,
                  };

                  updateDealInvestor(
                    orgId,
                    dealId,
                    investor.id,
                    updatedDealInvestor,
                    null,
                    () => {
                      setInvestor(rollbackInvestor);
                      setIsError(true);
                    }
                  );

                  setIsInvestorEdit(!isInvestorEdit);
                }}
              >
                save
              </Button>
            )}
          </Box>
        </Box>
      </DKFormContainer>
      <LegalEntitiesGridWrapper
        orgId={orgId}
        dealId={dealId}
        dealInvestorId={dealInvestorId}
        canEditInvestorInfo={canEditInvestorInfo(investor)}
        investmentDealLegalEntities={investmentDealLegalEntities}
        setInvestmentDealLegalEntities={setInvestmentDealLegalEntities}
        fetchDealLegalEntityInvestments={fetchDealLegalEntityInvestments}
      />
      <NewCashInvestmentGridWrapper
        orgId={orgId}
        dealId={dealId}
        dealInvestorId={dealInvestorId}
        deal={deal}
        investor={investor}
        canEditInvestorInfo={canEditInvestorInfo(investor)}
        investmentDealLegalEntities={investmentDealLegalEntities}
        formDataNewCashInvestments={formDataNewCashInvestments}
        setFormDataNewCashInvestments={setFormDataNewCashInvestments}
        fetchDealLegalEntityInvestments={fetchDealLegalEntityInvestments}
        newCashInvestments={newCashInvestments}
        setNewCashInvestments={setNewCashInvestments}
      />
      <SAFEConversionsGridWrapper
        dealId={dealId}
        deal={deal}
        dealInvestorId={dealInvestorId}
        canEditInvestorInfo={canEditInvestorInfo(investor)}
        investmentDealLegalEntities={investmentDealLegalEntities}
        safeInvestments={safeInvestments}
        setSafeInvestments={setSafeInvestments}
        fetchDealLegalEntityInvestments={fetchDealLegalEntityInvestments}
        orgId={orgId}
      />
      <DKFormContainer>
        <div className="investor-legal-entity-row">
          <div className="investor-legal-entity-label">Members</div>
          {canEditInvestorInfo(investor) && (
            <Button
              data-testid="button-add-investor-members"
              type="secondary"
              size="medium"
              onClick={() => {
                setIsOpenAddMemberPopup(true);
              }}
            >
              add
            </Button>
          )}
        </div>
        <Delimiter type="internal" shift={16} />
        {!!investorDealLegalEntities.length &&
          investorDealLegalEntities
            .filter(
              (dealInvestorMember) =>
                dealInvestorMember.legalEntityType ===
                api.InvestorLegalEntityType.Investor_Member
            )
            .sort((a, b) => {
              const memberA = getUserName(a.person);
              const memberB = getUserName(b.person);
              return simpleSort(memberA.toLowerCase(), memberB.toLowerCase());
            })
            .map((dealInvestorMember, key) => {
              return (
                <div key={key}>
                  <DealMemberRow
                    deletable={isUserCompanyMember}
                    invitable={isUserCompanyMember}
                    dealMember={dealInvestorMember}
                    editable={canEditInvestorInfo(investor)}
                    onInvite={() => {
                      sendPersonInvitation(
                        dealId,
                        dealInvestorMember.person.id,
                        C.USER_MEMBER_ROLE,
                        dealInvestorId
                      );
                    }}
                    onRemove={() => {
                      removeDealInvestorMember(
                        orgId,
                        dealId,
                        dealInvestorId,
                        dealInvestorMember.id,
                        () => {
                          setInvestorDealLegalEntities(
                            investorDealLegalEntities.filter(
                              (filteringDealInvestorMember) => {
                                if (
                                  dealInvestorMember.id !==
                                  filteringDealInvestorMember.id
                                ) {
                                  return filteringDealInvestorMember;
                                }
                              }
                            )
                          );
                        }
                      );
                    }}
                    showHeader={key === 0}
                  />
                </div>
              );
            })}
      </DKFormContainer>
      <AddMember
        open={isOpenAddMemberPopup}
        onClose={() => {
          setIsOpenAddMemberPopup(false);
        }}
        companyName={investor.name}
        isLead={investor.isLead}
        onAdd={(data) => {
          addNewPersonAsDealInvestorMember(
            orgId,
            dealId,
            dealInvestorId,
            {
              email: data.email,
              firstName: data.firstName,
              lastName: data.lastName,
            },
            (dealInvestorMember) => {
              setInvestorDealLegalEntities([
                ...investorDealLegalEntities,
                dealInvestorMember,
              ]);
            }
          );
        }}
        onAddExisting={(data) => {
          addExistingPersonAsDealInvestorMember(
            orgId,
            dealId,
            dealInvestorId,
            {
              personId: data.person_id,
            },
            (dealInvestorMember) => {
              setInvestorDealLegalEntities([
                ...investorDealLegalEntities,
                dealInvestorMember,
              ]);
            }
          );
        }}
        getPersons={searchPersons}
        persons={persons}
      />
    </DealsPageLayout>
  );
};

const mapStateToProps = (state, props) => {
  const {
    match: {
      params: { dealId, investor: investorId, orgId },
    },
  } = props;
  const { user, token } = state.auth;
  const { updated } = state.deals;

  return {
    user,
    token,
    updated,
    dealInvestorId: investorId,
    dealId,
    orgId,
    legalEntitiesFormFocus:
      props.location.state && props.location.state.legalEntitiesFormFocus,
  };
};

const mapDispatchToProps = (dispatch) => ({
  sendPersonInvitation: function (dealId, personId, personRole, investorId) {
    dispatch(
      Actions.sendPersonInvitation(dealId, personId, personRole, investorId)
    );
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DealInvestorDetailPage);
